import { Component } from '@angular/core'
import { ResetSentComponent } from '@ftr/ui-user'

@Component({
  selector: 'ftr-reset-sent-page',
  template: '<ftr-reset-sent></ftr-reset-sent>',
  imports: [ResetSentComponent],
})
export class ResetSentPage {}
